import { render, staticRenderFns } from "./DistributorTeam.vue?vue&type=template&id=1443254b&scoped=true&"
import script from "./DistributorTeam.vue?vue&type=script&lang=js&"
export * from "./DistributorTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1443254b",
  null
  
)

export default component.exports